function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import findIndex from 'lodash/findIndex';
import sortBy from 'lodash/sortBy';
import { registerAction, unregisterAction } from 'helpers/reducerTools';
import * as actionTypes from './actionTypes';
const initialState = {
    activeVisit: null,
    activeVisitPatientId: null,
    visits: [],
    fetching: [],
    sending: [],
    errors: []
};
export default function reducer(state = _object_spread({}, initialState), action = {}) {
    switch(action.type){
        case actionTypes.SET_VISIT_DATA:
            {
                const { phiVisit } = action.payload;
                const visitIdx = state.visits.findIndex((v)=>v.phisetVisitId === phiVisit.phisetVisitId);
                if (visitIdx === -1) {
                    return state;
                }
                const visits = [
                    ...state.visits
                ];
                visits[visitIdx] = _object_spread_props(_object_spread({}, phiVisit), {
                    metadata: visits[visitIdx].metadata
                });
                return _object_spread_props(_object_spread({}, state), {
                    visits
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.ADD_VISIT:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.ADD_VISIT),
                    errors: unregisterAction(state.errors, actionTypes.ADD_VISIT)
                });
            }
        case actionTypes.ADD_VISIT_SUCCESS:
            {
                const { visit, isInactive, patientId } = action.payload;
                if (isInactive) {
                    return _object_spread_props(_object_spread({}, state), {
                        sending: unregisterAction(state.sending, actionTypes.ADD_VISIT)
                    });
                }
                return _object_spread_props(_object_spread({}, state), {
                    activeVisit: visit,
                    activeVisitPatientId: patientId,
                    sending: unregisterAction(state.sending, actionTypes.ADD_VISIT)
                });
            }
        case actionTypes.ADD_VISIT_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.ADD_VISIT),
                    errors: registerAction(state.errors, actionTypes.ADD_VISIT)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.RESUME_VISIT:
            {
                const { visit, patientId } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    activeVisit: visit,
                    activeVisitPatientId: patientId
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.END_VISIT:
            {
                const { visitNotes } = action.payload;
                if (!visitNotes || !visitNotes.length) {
                    return _object_spread_props(_object_spread({}, state), {
                        activeVisit: null,
                        activeVisitPatientId: null,
                        sending: registerAction(state.sending, actionTypes.END_VISIT),
                        errors: unregisterAction(state.errors, actionTypes.END_VISIT)
                    });
                }
                const activeVisit = _object_spread({}, state.activeVisit);
                const visits = [
                    ...state.visits
                ];
                if (activeVisit) {
                    const idx = findIndex(visits, {
                        phisetVisitId: activeVisit.phisetVisitId
                    });
                    if (idx < 0) {
                        visits.push(activeVisit);
                    } else {
                        visits[idx] = activeVisit;
                    }
                }
                return _object_spread_props(_object_spread({}, state), {
                    activeVisit: null,
                    activeVisitPatientId: null,
                    visits,
                    sending: registerAction(state.sending, actionTypes.END_VISIT),
                    errors: unregisterAction(state.errors, actionTypes.END_VISIT)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_VISIT_METADATA:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_VISIT_METADATA),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_VISIT_METADATA)
                });
            }
        case actionTypes.FETCH_VISIT_METADATA_SUCCESS:
            {
                const { visit } = action.payload;
                const activeVisit = visit.phisetVisitId === state.activeVisit.phisetVisitId ? visit : state.activeVisit;
                return _object_spread_props(_object_spread({}, state), {
                    activeVisit,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_VISIT_METADATA)
                });
            }
        case actionTypes.FETCH_VISIT_METADATA_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_VISIT_METADATA),
                    errors: registerAction(state.errors, actionTypes.FETCH_VISIT_METADATA)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_VISITS_METADATA:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_VISIT_METADATA),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_VISIT_METADATA)
                });
            }
        case actionTypes.FETCH_VISITS_METADATA_SUCCESS:
            {
                const visits = sortBy([
                    ...state.visits,
                    ...action.payload.visits
                ], (v)=>v.metadata.visitDate);
                return _object_spread_props(_object_spread({}, state), {
                    visits,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_VISIT_METADATA)
                });
            }
        case actionTypes.FETCH_VISITS_METADATA_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_VISIT_METADATA),
                    errors: registerAction(state.errors, actionTypes.FETCH_VISIT_METADATA)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.CLEAR_VISITS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    visits: []
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        default:
            {
                return state;
            }
    }
}
